import appConsts from 'client/constants/appConsts';

export default (fileNameOrLink: string) => {
	if (/^http/.test(fileNameOrLink)) {
		return fileNameOrLink;
	}
	return `${appConsts.uploadUrl}/${fileNameOrLink}`;
};
